import CommentVotesEntity from "components/comment-votes/js/models/comment-votes-entity"
import { PHOTO_COMMENT_AUTHOR, PHOTO_COMMENT_ID, PHOTO_COMMENT_TEXT } from "../constants"

class CommentEntity {
  /**
   * Creates an instance of CommentEntity.
   * @param {Object} settings
   * @param {Number} settings.id
   * @param {Number} settings.timestamp
   * @param {String} settings.authorName
   * @param {String} settings.bodyText
   * @param {CommentVotesEntity} settings.votes
   * @memberof CommentEntity
   */
  constructor({ id, timestamp, authorName, bodyText, votes }) {
    this.id = id
    this.timestamp = timestamp
    this.authorName = authorName
    this.bodyText = bodyText
    this.votes = votes
  }

  /**
   * @param {Object} settings
   * @param {Number} settings.id
   * @param {Number} settings.timestamp
   * @param {String} settings.authorName
   * @param {String} settings.bodyText
   * @param {CommentVotesEntity} settings.votes
   * @memberof CommentEntity
   */
  copyWith({ id, timestamp, authorName, bodyText, votes }) {
    return new CommentEntity({
      id: id === undefined ? this.id : id,
      timestamp: timestamp === undefined ? this.timestamp : timestamp,
      authorName: authorName === undefined ? this.authorName : authorName,
      bodyText: bodyText === undefined ? this.bodyText : bodyText,
      votes: votes === undefined ? this.votes : votes,
    })
  }

  /**
   * @static
   * @param {object} json
   * @returns
   * @memberof CommentEntity
   */
  static fromJson(json) {
    return new CommentEntity({
      id: json.id,
      timestamp: Date.parse(json.created_at),
      authorName: json.author_name,
      bodyText: json.body,
      votes: CommentVotesEntity.fromJson(json.votes),
    })
  }

  /**
   * @static
   * @param {HTMLElement} htmlElement
   * @returns
   * @memberof CommentEntity
   */
  static fromHtmlElement(htmlElement) {
    let elementWithId
    if (htmlElement.dataset.commentId) {
      elementWithId = htmlElement
    } else {
      elementWithId = htmlElement.querySelector(PHOTO_COMMENT_ID)
    }

    const authorElement = htmlElement.querySelector(PHOTO_COMMENT_AUTHOR)
    const bodyElement = htmlElement.querySelector(PHOTO_COMMENT_TEXT)

    return new CommentEntity({
      id: Number(elementWithId.dataset.commentId) || null,
      timestamp: null,
      authorName: authorElement.textContent,
      bodyText: bodyElement.textContent,
      votes: CommentVotesEntity.fromHtmlElement(htmlElement),
    })
  }
}

export default CommentEntity
